var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[_vm.logoInterno && _vm.logoInterno.id ? 'sidebar-nav-footer-logo' : 'sidebar-nav-footer'],style:({background: ("url(" + _vm.logoInterno + ") center bottom no-repeat"), backgroundSize: 'contain'})})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6c45560","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/footer.vue
// module id = 810
// module chunks = 245